export default "__VITE_ASSET__PCXmuQXC__"